<script>
import { getConversationClassByState } from 'dashboard/helper/conversationHelper';

export default {
  props: {
    chat: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedClass() {
      const { status } = this.chat;
      return getConversationClassByState(status);
    },
  },
};
</script>

<template>
  <div
    class="inbox--name inline-flex items-center py-0.5 px-0 leading-3 whitespace-nowrap bg-none text-slate-600 dark:text-slate-500 text-xs my-0 mx-1"
  >
    <fluent-icon
      class="mr-0.5 rtl:ml-0.5 rtl:mr-0"
      :icon="computedClass"
      size="12"
      icon-lib="tabler"
    />
    {{ chat.id }}
  </div>
</template>
